import VueCookies from 'vue-cookies-ts';
import Vue from 'vue';
import App from './App.vue';
import store from './store';

Vue.config.productionTip = false;
Vue.use(VueCookies);
const rootElement = document.getElementById('explorequebecwidget');
if (rootElement && rootElement.dataset) {
  store.state.exploreqcid = Number(rootElement.dataset.exploreqcid);
}

new Vue({
  store,
  render: (h) => h(App),
}).$mount('#explorequebecwidget');
